// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"4c38f583","156":"3b7150cc"}[chunkId] + ".chunk.js";
};